import React from "react";

/** Light section wrapper with editorial header. */
export default function SectionShell({
  id,
  eyebrow,
  title,
  intro,
  children,
  variant = "default",
  ...props
}) {
  const bg = variant === "elevated" ? "#F7F5EF" : "#FFFFFF";
  return (
    <section
      id={id}
      className="relative py-20 md:py-32 overflow-hidden scroll-mt-20"
      style={{ background: bg }}
      {...props}
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12 relative z-10">
        {(eyebrow || title || intro) && (
          <header className="max-w-2xl mb-12 md:mb-16">
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            {title && (
              <h2 className="font-display text-[#0B1F3F] text-4xl sm:text-5xl tracking-tight mt-4 leading-[1.08]">
                {title}
              </h2>
            )}
            {intro && (
              <p className="text-[#5A6476] mt-5 text-base md:text-lg leading-relaxed max-w-xl">
                {intro}
              </p>
            )}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <div
      className={`flex items-center gap-3 text-[10.5px] sm:text-[11px] tracking-[0.22em] sm:tracking-[0.3em] uppercase font-semibold text-[#8A6A2E] ${className}`}
    >
      <span className="h-px w-8 bg-[#B08D57]" />
      {children}
    </div>
  );
}
